import { createDataStore } from "./common";

export default createDataStore({
  storeKey: "iabCategories",
  endpoint: process.env.REACT_APP_PLACES_API_HOST + "/iabCategories",
  idKey: "iab_category_id"
});
